export function createReducer(initialState = {}, events = {}) {
  return (state = initialState, action = {}) => {
    const event = events[action.type];
    if (event) {
      return event(state, action);
    }
    return state;
  };
}